import { Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';


export const programId = '644bece77d0ebd409f74cfd1';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    useFingerprinting: true,
};
